<template>
    <div class="share">
        <div class="stone_logo"><img  src="../assets/images/insects/stone_logo.png"></div>
        <div class="done">
            <h2>恭喜你成为 <span>HZ{{code}}</span> 号探员！</h2>
            <h2>你出色地完成了这次混知调查局的<br>昆虫大发现任务！ <br>特此颁发荣誉徽章。</h2>
        </div>
        <div class="listen"><img  src="../assets/images/insects/qrcode.png"></div>
        <p>扫码免费收听21集昆虫大发现音频课程</p>
    </div>
</template>
<script>
export default {
    data(){
        return{
            code:''
        }
    },
    mounted(){
        this.getId()
    },
    methods:{
        getId(){
            if(localStorage.getItem('userInfo')){
                let id= JSON.parse(localStorage.getItem('userInfo')).id+'';
                if(id.length==1){
                    this.code='0000'+id
                }else if(id.length==2){
                    this.code='000'+id
                }else if(id.length==3){
                    this.code='00'+id
                }else if(id.length==4){
                    this.code='0'+id
                }else{
                    this.code=id
                }
            }           
        }
    }
}
</script>
<style scoped>
.share{
    width: 100%;
    height: 100%;
    background: url('../assets/images/insects/bg03.jpg');
    background-size: 100% 100%;
    text-align: center
}
.share .stone_logo{  
    text-align: center
}
.share .stone_logo img{
    margin-top: 75px;
    width: 535px;
    height: 537px;
}
.done{
    margin-top: 40px;    
}
.done h2{
    color: #ECBC68;
    font-size: 36px;
    line-height: 70px;
}
.done h2 span{
    color: #FFFFFF;
}
.listen img{
    width: 223px;
    height: 271px;
}
p{
    margin-top: 20px;
    font-size: 26px;
    color: #FBE3B8
}
</style>
